import { vec3Result } from "./vec3";

export type BarycentricWeights = [number, number, number];

// Shared denominator of the barycentric weights: twice the triangle's signed area. Zero or
// non-finite means the triangle has no valid barycentric mapping.
export function barycentricDenominatorFromTriangle(
  x0: number,
  y0: number,
  x1: number,
  y1: number,
  x2: number,
  y2: number,
): number {
  return (y1 - y2) * (x0 - x2) + (x2 - x1) * (y0 - y2);
}

export function barycentricWeightsFromTriangle(
  x0: number,
  y0: number,
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  px: number,
  py: number,
): BarycentricWeights {
  const denominator = barycentricDenominatorFromTriangle(x0, y0, x1, y1, x2, y2);
  vec3Result[0] = ((y1 - y2) * (px - x2) + (x2 - x1) * (py - y2)) / denominator;
  vec3Result[1] = ((y2 - y0) * (px - x2) + (x0 - x2) * (py - y2)) / denominator;
  vec3Result[2] = 1 - vec3Result[0] - vec3Result[1];
  return vec3Result;
}

export function barycentricWeightsInside(w0: number, w1: number, w2: number): boolean {
  return w0 >= 0 && w1 >= 0 && w2 >= 0;
}

export function interpolateWithBarycentricWeights(
  u0: number,
  u1: number,
  u2: number,
  w0: number,
  w1: number,
  w2: number,
): number {
  return u0 * w0 + u1 * w1 + u2 * w2;
}
